// @flow
import i18n from 'i18n-js';

// Buttons
export const Cancel = () => i18n.t('buttons.cancel');
export const Delete = () => i18n.t('buttons.delete');
// Create Button, recibe un componente de mensaje
export const CreateButton = (item: string) => i18n.t('buttons.create', { Item: item });

// Common
export const Boolean = (value: boolean) => i18n.t(`common.${value ? 'booleanTrue' : 'booleanFalse'}`);
export const Loading = (Item: string) => i18n.t('common.loading', { Item });
export const ConfirmDeletion = (item?: string) => i18n.t('common.confirmDeletion', { Item: item });
export const NoResults = (Item: String) => i18n.t('common.noResults', { Item });
export const Search = (Item: string, count: number) => i18n.t('common.searchItem', { Item, count });



// WEBPACK FOOTER //
// ./src/scripts/components/CommonTexts/index.js